import { Injectable } from '@angular/core';

// eslint-disable-next-line no-unused-vars
import * as _ from 'lodash';
import { Store } from '@ngxs/store';
import { UserInfo } from '../store/base.action';
import { BaseSharedState } from '../store/base.state';
import { EnvironmentService } from '../services/environment.service';
import { UserInfoService } from '../services/user-info.service';
import { CookieService } from 'ngx-cookie-service';

// TODO : Create angular InjecctionToken service to store token
@Injectable({
  providedIn: 'root'
})

export class StorageService {
  public static readonly CONST = {
    'CUSTOM_ROLE': 'custom-role',
    'ROLES':'roles'
  };
  constructor(private cookie: CookieService,
    private store: Store,
    private env: EnvironmentService,
    private userInfoService: UserInfoService) { }

  setLocalStorageItem(key: string, value: string){
    console.log('StorageService -> ',key);
    if(key === StorageService.CONST.CUSTOM_ROLE || key === StorageService.CONST.ROLES){
      this.store.dispatch( new UserInfo(key, value));
    } else {
      const envVal:any = this.env.getEnvironment();
      if (!envVal.production) {
        this.cookie.set(btoa(key), btoa(value));
      }else{
        this.cookie.set(btoa(key), btoa(value), this.userInfoService.getCookiesExpires(), window.location.pathname, window.location.hostname, true, "None");
      }
    }
  }

  getLocalStorageItem(key: string): string{
    console.log('StorageService -> ',key);
    if(key === StorageService.CONST.CUSTOM_ROLE || key === StorageService.CONST.ROLES){
      const userInfo = this.store.selectSnapshot<any>((state: BaseSharedState)=>state['baseShared'].userInfo);
      if(userInfo[key])
        return userInfo[key];
      else
        return "[]";
    } else {
      return atob(this.cookie.get(btoa(key)));
    }
  }

  setSessionStorageItem(key: string, value: string){
    console.log('StorageService -> ',key);
    if(key === StorageService.CONST.CUSTOM_ROLE || key === StorageService.CONST.ROLES){
      this.store.dispatch( new UserInfo(key, value));
    } else {
      const envVal:any = this.env.getEnvironment();
      if (!envVal.production) {
        this.cookie.set(btoa(key), btoa(value));
      }else{
        this.cookie.set(btoa(key), btoa(value), this.userInfoService.getCookiesExpires(), window.location.pathname, window.location.hostname, true, "None");
      }

    }
  }

  getSessionStorageItem(key: string): string{
    console.log('StorageService -> ',key);
    if(key === StorageService.CONST.CUSTOM_ROLE || key === StorageService.CONST.ROLES){
      const userInfo = this.store.selectSnapshot<any>((state: BaseSharedState)=>state['baseShared'].userInfo);
      if(userInfo[key])
        return userInfo[key];
      else
        return "[]";
    } else {
      return atob(this.cookie.get(btoa(key)));
    }
  }

  clearData(){
    const envVal:any = this.env.getEnvironment();
    if (!envVal.production) {
      this.cookie.deleteAll();
    }else{
      this.cookie.deleteAll(window.location.pathname, window.location.hostname);
    }
  }

  removeSetSessionStorageData(key:string){
    const envVal:any = this.env.getEnvironment();
    if (!envVal.production) {
      this.cookie.delete(btoa(key));
    }else{
      this.cookie.delete(btoa(key), window.location.pathname, window.location.hostname);
    }
  }
  removesetLocalStorageData(key:string){
    const envVal:any = this.env.getEnvironment();
    if (!envVal.production) {
      this.cookie.delete(btoa(key));
    }else{
      this.cookie.delete(btoa(key), window.location.pathname, window.location.hostname);
    }
  }
}
